import { useState } from "react";
import "./Styles/styles.css";
import { toast } from "react-toastify";

export const Form = ({ listTransactions, setListTransactions }) => {
  const [describe, setDescribe] = useState("");
  const [value, setValue] = useState(0);
  const [type, setType] = useState("entrada");
  const [id, setId] = useState(0);
  // const infoTransactions = { describe, value, type };

  const submitTransaction = (event) => {
    event.preventDefault();
    if (!describe || !value || !type) {
      return toast.error("Form incompleto!!!");
    }
    if (type === "entrada") {
      setListTransactions([...listTransactions, { describe, value, type, id }]);
    } else {
      setListTransactions([
        ...listTransactions,
        { describe, value: -value, type, id },
      ]);
    }
    setId(id + 1);
    toast.success("Adicionado com sucesso!");
  };

  return (
    <main className="container-form">
      <form
        onSubmit={(event) => {
          submitTransaction(event);
        }}
        className="form"
      >
        <div className="description">
          <h1>Descrição</h1>
          <input
            type="text"
            placeholder="Digite aqui sua descrição"
            onChange={(e) => setDescribe(e.target.value)}
          />
          <h4>Ex: Compra de roupas</h4>
        </div>
        <div className="form-value">
          <p>Valor</p>
          <p>Tipo de valor</p>
        </div>
        <div className="form-select">
          <input
            type="number"
            onChange={(e) => setValue(e.target.value)}
            placeholder="        R$"
          />
          <select onChange={(e) => setType(e.target.value)}>
            <option value="entrada">Entrada</option>
            <option value="saida">Saída</option>
          </select>
        </div>
        <button type="submit" className="form-button">
          Inserir valor
        </button>
      </form>
    </main>
  );
};
